import axios from "axios";
import Chatbutton from '../components/chatbutton'
import 'bootstrap/dist/css/bootstrap.css';
import '../styles/chatbutton.css'
import '../styles/ProductsScreen.css'
import React from "react";

export default class ProductsScreen extends React.Component {
  state = {
    posts: [],
    bLoaded:false
  }

  componentDidMount() {
    axios.get(`https://shoppee-clone.herokuapp.com/products`)
      .then(res => {
        const posts = res.data;
        console.log(res.data);
        if(res.data.length > 0)
            {
                const posts = [];

                for (var i=0; i<res.data.length; i++) 
                {
                    
                        posts.push();
                  
                }

                this.setState({
                    aList: posts,
                    bLoaded: true
                });

                this.forceUpdate();
            }
            else
            {
                this.setState({
                    aList: <p className='BigText'>Nothing</p>,
                    bLoaded: true
                });

                this.forceUpdate();
            }
        
    
        this.setState({ posts });
        })
    }

  render() {
    return (

      <div>
        <div className="container justify-content-center " >{this.state.bLoaded ? this.state.aList : <img src={require('../assets/load.gif')} alt="loading..." width={500} id="loading"/>}</div>
        {this.state.posts.map(post =>
          <div className="card container-fluid" id="cardproduct">
            <img className="card-img w-100 h-100 rounded" src={'images/' + post.image} />
            <p className="productname h4 text text-dark">{post.name}</p>
            <p className="productbrand text text-dark">{post.brand}</p>
            <p className="productprice h2 text text-dark">${post.price}</p>
            <a href={'SingleProduct?productid=' + post.productid} className="stretched-link" /></div>)}
        <Chatbutton ></Chatbutton>
      </div>
    )
  }
}

